import {Header} from "../components/Header";
import {Group} from '@mantine/core';
import {GettingStartedTextSection} from "../components/GettingStartedTextSection";
import {GettingStartedNav} from "../components/GettingStartedNav";
import {TableOfContents} from "../components/TableOfContents";

const GettingStartedPage = () => {
    return (
        <>
            <Header/>
            <Group style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
                   align="flex-start"
                   justify="space-between"
                   wrap="nowrap"
                   gap="xl"
            >
                <TableOfContents/>
                <GettingStartedTextSection/>
                <GettingStartedNav/>
            </Group>
        </>
    )
}

export default GettingStartedPage;